<template>
    <div ref="modal" class="modal fade" :class="{ show: active, 'd-block': active }" tabindex="-1" role="dialog">
      <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">List Charge Code</h5>
            <button type="button" class="btn-close" data-bs-dismiss="modal" v-on:click="$emit('closeModal')"
              aria-label="btn-close"></button>
          </div>
  
          <form class="forms-sample" method="POST" ref="formElement" @submit.prevent="submitData">
            <div class="modal-body">
             
                <table class="table table-responsive">
                    <thead>
                        <tr>
                            <th>No</th>
                            <th>Charge Code</th>
                            <th>Charge Name</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-show="data.length <= 0">
                            <td colspan="3" style="text-align: center;">Empty Data</td>
                        </tr>
                        <tr v-for="(list,key) in data " :key="key">
                            <td>{{ key + 1 }}</td>
                            <td>{{ list.charge_code }}</td>
                            <td>{{ list.charge_name }}</td>
                        </tr>
                    </tbody>
                </table>
           
  
    
  
  
           
  
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-secondary" v-on:click="$emit('closeModal')">
                Close
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </template>
    
  <script>
  export default {
    components: {
    },
    name: "modalAddCostList",
    emits: ["closeModal"],
  
    props: {
      showModal: Boolean,
      data: null,
    },
    watch: {
      showModal: {
        handler(newVal) {
          this.active = newVal;
          const body = document.querySelector("body");
          this.showModal
            ? body.classList.add("modal-open")
            : body.classList.remove("modal-open");
           
        },
        immediate: true,
        deep: true,
      },
    },
    data() {
      return {
        active: this.showModal,
      };
    },
    methods: {
      resultError(data) {
        var html = "";
        var count = Object.keys(data).length;
        for (var x = 0; x < count; x++) {
          var nameOb = Object.keys(data)[x];
          var objectData = data[nameOb];
          for (var y = 0; y < objectData.length; y++) {
            html += objectData[y] + "<br>";
          }
        }
  
        this.loadError(html);
      },
  
      loadError(pesan) {
        this.$swal({
          backdrop: true,
          title: "Warning",
          html: pesan,
          showConfirmButton: true,
          allowOutsideClick: false,
          allowEscapeKey: false,
        }).then((result) => {
          if (result.value) {
            this.isLoading=false;
          }
        })
      },
  
  
  
      loadSuccess(pesan) {
        this.$swal({
          backdrop: true,
          title: "Success",
          html: pesan,
          showConfirmButton: true,
          allowOutsideClick: false,
          allowEscapeKey: false,
        }).then((result) => {
          if (result.value) {
            this.isLoading=false;
          }
        })
      },
  
     
    },
    created: function () {
      //this.loadDriver();
  
    },
    mounted() {
    //   this.loadForUsers();
    //   this.loadMasterAksesLoop();

      const formElement = this.$refs.formElement;
        if (formElement) {
          const observer = new MutationObserver((mutations) => {
            mutations.forEach((mutation) => {
              if (mutation.type === 'attributes' && mutation.attributeName === 'readonly') {
                const inputs = formElement.querySelectorAll('.multiselect__input');
                inputs.forEach(input => {
                  input.removeAttribute('readonly');  // Hapus readonly setiap kali diubah
                });
              }
            });
          });

          const inputs = formElement.querySelectorAll('.multiselect__input');
          inputs.forEach(input => {
            observer.observe(input, { attributes: true });
          });
        }


      //tail(this.data);
    },
  };
  </script>
    
  <style scoped>
  .modal {
    background: rgba(0, 0, 0, 0.4);
  }
  
  .modal-content {
    background: #fff;
    border-radius: 0px;
    border: none;
    box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.2);
    padding: 0px;
    width: 100%;
    height: 100%;
    margin-left: 0px !important;
  }
  </style>